import {
  FooterContainer,
  FooterButtons,
  StepTitle,
  FooterButton,
  WizardContentWrapper,
  FooterBackButton,
} from "@/components/onboarding/components/ImportWizard/StyledComponents";
import { StepProps } from "@/components/onboarding/components/ImportWizard/ImportWizard.types";
import styled from "@emotion/styled";

export const SkipConfirmationStep = ({ onClose, onNavToStep }: StepProps) => {
  return (
    <WizardContentWrapper>
      <StepTitle>
        You can always bring in notes from other apps later so you can find them with Mem Search,
        Chat, and Copilot
      </StepTitle>

      <GifWrapper>
        <img
          src={"/onboarding/import-howto.gif"}
          alt="Click the dropdown arrow next to the Create note button and then select Import"
          width="544px"
          height="183px"
        />
      </GifWrapper>

      <FooterContainer>
        <FooterButtons>
          <FooterBackButton onClick={() => onNavToStep?.("app-selection")} />
          <FooterButton color="contrast" onClick={() => onClose?.()}>
            Got it
          </FooterButton>
        </FooterButtons>
      </FooterContainer>
    </WizardContentWrapper>
  );
};

const GifWrapper = styled.div`
  box-shadow: ${({ theme }) => theme.shadows.popover};
  width: 544px;
  height: 183px;
  border-radius: ${({ theme }) => theme.borderRadius.mediumLarge + "px"};
  overflow: hidden;
`;
